import React from "react";
import { Sailboat, Heart, Users, Wind, Sparkles, Compass, PawPrint } from "lucide-react";

const reasons = [
  { icon: Sailboat, title: "50 años navegando historia", desc: "Un velero clásico de madera de 18 metros, con biografía propia: navegación, restauración y cultura marítima en su historia." },
  { icon: Heart, title: "Privado y exclusivo", desc: "Reserva el barco completo. Hasta 12 pasajeros más tripulación. Tu grupo, tu ritmo, sin masificaciones." },
  { icon: Users, title: "Trato cercano", desc: "Te escuchamos primero. Cada salida se piensa para tu grupo, no en serie." },
  { icon: Wind, title: "Navegación tranquila", desc: "Sin prisas, sin ruido. El placer de navegar despacio en una pieza viva del patrimonio marítimo." },
  { icon: Sparkles, title: "Imagen de cine", desc: "Una estética que ha formado parte de eventos, documentales y cine, incluida Romería, de Carla Simón." },
  { icon: Compass, title: "Entorno único", desc: "Salida desde Portonovo, junto al entorno del Parque Nacional das Illas Atlánticas. Navegación responsable y respeto por el mar." },
  { icon: PawPrint, title: "Dog friendly", desc: "Los perros también navegan. Son bienvenidos a bordo, siempre con respeto por el barco y por el resto del grupo." },
];

export default function WhyChoose() {
  return (
    <section id="por-que" className="section-pad bg-navy text-white" data-testid="why-section">
      <div className="container-tight">
        <div className="max-w-3xl">
          <p className="label-eyebrow text-sand mb-4">Por qué Zorba</p>
          <h2 className="font-heading text-4xl md:text-5xl leading-tight" data-testid="why-title">
            Un velero de cine, con 50 años de historia.
          </h2>
          <p className="mt-5 text-white/75 text-lg leading-relaxed">
            El Zorba no es una propuesta en serie. Es un barco con biografía propia, un patrón cercano y una forma tranquila, cuidada y elegante de vivir el mar.
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
          {reasons.map((r, i) => (
            <div key={r.title} className="group" data-testid={`why-item-${i}`}>
              <div className="w-12 h-12 rounded-full border border-sand/40 flex items-center justify-center text-sand mb-5 group-hover:bg-sand/10 transition-colors">
                <r.icon size={20} strokeWidth={1.5} />
              </div>
              <h3 className="font-heading text-2xl text-white">{r.title}</h3>
              <p className="mt-3 text-white/70 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
